/**   
 * 预约管理
 */
export default {
  reserveOrderList: "/project_reservation/project_reservation_list", //预约列表
  reserveOrderInfo: "/project_reservation/project_reservation_info", //预约详情
};